import { useDispatch, useSelector } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import {
	agentApi,
	analyticsApi,
	api,
	accessApi,
	billingCustomerApi,
	meetingApi,
	workflowApi,
} from './api/base';
import authReducer from './features/authSlice';
import autopilotsReducer from './features/autopilotsSlice';
import enterpriseReducer from './features/enterpriseSlice';
import searchSelectionReducer from './features/searchSelectionSlice';
import tenantConfigReducer from './features/tenantConfigSlice';
import tenantsReducer from './features/tenantsSlice';
import userPreferencesReducer from './features/userPreferencesSlice';

import type { ConfigureStoreOptions } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';

// const appReducer = combineReducers({
// 	[api.reducerPath]: api.reducer,
// 	[agentApi.reducerPath]: agentApi.reducer,
// 	tenantConfigState: tenantConfigReducer,
// 	tenantsState: tenantsReducer,
// 	authState: authReducer,
// 	autopilotsState: autopilotsReducer,
// 	enterpriseState: enterpriseReducer,
// });

// const rootReducer = (
// 	state: ReturnType<typeof appReducer> | undefined,
// 	action: Action,
// ) => {
// 	if (action.type === 'LOGOUT') {
// 		return appReducer(undefined, action);
// 	}

// 	return appReducer(state, action);
// };

export const createStore = (
	options?: ConfigureStoreOptions['preloadedState'] | undefined,
) =>
	configureStore({
		reducer: {
			[api.reducerPath]: api.reducer,
			[agentApi.reducerPath]: agentApi.reducer,
			[meetingApi.reducerPath]: meetingApi.reducer,
			[analyticsApi.reducerPath]: analyticsApi.reducer,
			[workflowApi.reducerPath]: workflowApi.reducer,
			[accessApi.reducerPath]: accessApi.reducer,
			[billingCustomerApi.reducerPath]: billingCustomerApi.reducer,
			tenantConfigState: tenantConfigReducer,
			tenantsState: tenantsReducer,
			authState: authReducer,
			autopilotsState: autopilotsReducer,
			enterpriseState: enterpriseReducer,
			userPreferencesState: userPreferencesReducer,
			searchSelectionState: searchSelectionReducer,
		},
		devTools: process.env.NODE_ENV === 'development',
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().concat(
				api.middleware,
				agentApi.middleware,
				meetingApi.middleware,
				analyticsApi.middleware,
				workflowApi.middleware,
				accessApi.middleware,
				billingCustomerApi.middleware,
			),
		...options,
	});

export const store = createStore();
setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
